interface CaptionProps {
  text: string
  variant: 'white' | 'gray'
  className?: string
}

const variants = {
  white: 'text-white bg-white/[25%] border-[#999DAD]',
  gray: 'text-reeve-secondary-gray bg-reeve-primary/[5%] border-[#CCCED6]',
}
export const Caption = ({ text, variant, className }: CaptionProps) => {
  return (
    <div
      className={`${className} paragraph-s rounded-lg border px-2 py-1 text-center text-[0.8125rem] font-semibold uppercase leading-none tracking-wide ${
        variant === 'white' ? variants.white : variants.gray
      }`}
    >
      {text}
    </div>
  )
}
